import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { FaList, FaUser } from 'react-icons/fa'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import { IoIosArrowBack, IoIosArrowForward, IoIosHome } from 'react-icons/io'
import { FaBorderAll } from 'react-icons/fa6'
import { FaHeart } from 'react-icons/fa'
import { IoMdLogOut } from 'react-icons/io'
import api from '../api/api'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { user_reset } from '../store/reducers/authReducer'
import { reset_count } from '../store/reducers/cardReducer'

const Dashboard = () => {
  const [filterShow, setFilterShow] = useState(false)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'

  const logout = async () => {
    try {
      const { data } = await api.get('/customer/logout')
      localStorage.removeItem('customerToken')
      dispatch(user_reset())
      dispatch(reset_count())
      navigate('/login')
    } catch (error) {
      console.log(error.response.data)
    }
  }

  return (
    <div>
      <Header />
       <section>
                <div className=" bg-slate-100 py-5 mb-2 mt-5">
                  <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
                    <div className="flex justify-start items-center text-md text-slate-600 w-full">
                      <Link to="/"> {t('home.home')}</Link>
                      <span>
                        <span>
                          {isRTL ? <IoIosArrowBack /> : <IoIosArrowForward />}
                        </span>
                      </span>
                      <span>{t('dashboardS.dashboard')}{' '}</span>
                    </div>
                  </div>
                </div>
              </section>
      <div className="w-[70%] md:w-[80%] sm:w-[95%] lg:w-[90%] h-full mt-4 mx-auto">
        <div className="w-[90%] mx-auto md-lg:block hidden">
          <div>
            <button
              onClick={() => setFilterShow(!filterShow)}
              className="text-center py-3 px-3 bg-primary text-white"
            >
              <FaList />{' '}
            </button>
          </div>
        </div>
       
        

        <div className="h-full mx-auto">
          <div className="py-5 flex md-lg:w-[95%] mx-auto relative">
            <div
              className={`rounded-md z-50 md-lg:absolute ${
                filterShow
                  ? isRTL
                    ? '-right-4'
                    : '-left-4'
                  : isRTL
                  ? '-right-[360px]'
                  : '-left-[360px]'
              } w-[270px] mx-4 bg-white border h-[600px] sm:h-auto`}
            >
              <ul className="py-2 text-slate-600 px-4 ">
                <li
                  onClick={() => setFilterShow(!filterShow)}
                  className="flex justify-start items-center gap-2 py-3"
                >
                  <span className="text-xl">
                    <IoIosHome />
                  </span>
                  <Link to="/dashboard" className="block">
                    {t('dashboardS.dashboard')}{' '}
                  </Link>
                </li>
                <li
                  onClick={() => setFilterShow(!filterShow)}
                  className="flex justify-start items-center gap-2 py-3"
                >
                  <span className="text-xl">
                    <FaUser />
                  </span>
                  <Link to="/dashboard/profile" className="block">
                    {t('dashboardS.profile')}{' '}
                  </Link>
                </li>
                <li
                  onClick={() => setFilterShow(!filterShow)}
                  className="flex justify-start items-center gap-2 py-3"
                >
                  <span className="text-xl">
                    <FaBorderAll />
                  </span>
                  <Link to="/dashboard/my-orders" className="block">
                    {t('dashboardS.orders')}{' '}
                  </Link>
                </li>
                <li
                  onClick={() => setFilterShow(!filterShow)}
                  className="flex justify-start items-center gap-2 py-3"
                >
                  <span className="text-xl">
                    <FaHeart />
                  </span>
                  <Link to="/dashboard/my-wishlist" className="block">
                    {t('dashboardS.wishlist')}{' '}
                  </Link>
                </li>
                {/* <li onClick={() => setFilterShow(!filterShow)} className="flex justify-start items-center gap-2 py-2">
                  <span className="text-xl">
                    <IoChatbubbleEllipsesSharp />
                  </span>
                  <Link to="/dashboard/chat" className="block">
                    Chat{' '}
                  </Link>
                </li> */}

                <li
                  onClick={logout}
                  className="flex justify-start items-center gap-2 py-2 cursor-pointer"
                >
                  <span className="text-xl">
                    <IoMdLogOut />
                  </span>
                  <div className="block"> {t('dashboardS.logout')} </div>
                </li>
              </ul>
            </div>

            <div className="w-[calc(100%-270px)] md-lg:w-full">
              <div className="mx-4 md-lg:mx-0">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Dashboard
